import { gql } from '@apollo/client';

const CustomerCheckQuery = gql`
  query CustomerCheckQuery {
    user {
      id
      testmode
      customer {
        id
        isInCohort
        isNewCustomer
      }
    }
  }
`;

export default CustomerCheckQuery;
